// GENEROWANE AUTOMATYCZNIE przez scripts/update-content-dates.mjs
// Nie edytuj ręcznie. Uruchom: bun run content:dates
export type ContentDateEntry = { hash: string; dateModified: string };

export const contentDates: Record<string, ContentDateEntry> = {
  "/": { hash: "4d5a4e0be9be56e7", dateModified: "2026-10-13" },
  "/wystapienia": { hash: "619f74d51ea5c85d", dateModified: "2026-10-13" },
  "/podcast": { hash: "a43b21ffc9e6f63a", dateModified: "2026-10-13" },
  "/mastermind": { hash: "f1628390cde2fb7f", dateModified: "2026-10-02" },
  "/konsultacje": { hash: "65ef2c1cd9b8ada5", dateModified: "2026-10-02" },
  "/psychologia-biznesu": { hash: "413aa27d6fd90c3a", dateModified: "2026-10-13" },
  "/o-mnie": { hash: "f7d6961a76ab0e18", dateModified: "2026-10-13" },
  "/media-i-publikacje": { hash: "899d85667fc6c100", dateModified: "2026-10-13" },
  "/test-na-wypalenie-zawodowe": { hash: "9b0aa9e71e8ed62b", dateModified: "2026-10-02" },
  "/syndrom-oszusta": { hash: "468c9634bae152b5", dateModified: "2026-10-13" },
  "/perfekcjonizm": { hash: "2c2bc5a950a2db65", dateModified: "2026-10-13" },
  "/stres-w-pracy-a-decyzje": { hash: "20ed530ba48b6f95", dateModified: "2026-10-13" },
  "/samotnosc-lidera": { hash: "a6c17a10d9d82008", dateModified: "2026-10-13" },
  "/wypalenie-zawodowe-u-lidera": { hash: "72fccfb62b6cdff1", dateModified: "2026-10-13" },
  "/mastermind-dla-przedsiebiorcow": { hash: "7e7c29a18debe1b5", dateModified: "2026-09-12" },
  "/delegowanie-zadan": { hash: "93c43e7e30ecd471", dateModified: "2026-09-14" },
  "/konflikt-ze-wspolnikiem": { hash: "58cb34de6f4c087e", dateModified: "2026-09-21" },
  "/psychologia-przywodztwa": { hash: "99a25f224ae1880e", dateModified: "2026-10-02" },
  "/stawianie-granic-w-pracy": { hash: "9a0dbff7fd52e197", dateModified: "2026-10-13" },
  "/kontakt": { hash: "abecc3f2941b7949", dateModified: "2026-09-28" },
  "/rezerwacja": { hash: "acdd82d99ac73925", dateModified: "2026-10-02" },
  "/sitemap": { hash: "8ea2bf9b363b9ccd", dateModified: "2026-10-02" },
  "/polityka-prywatnosci": { hash: "9a0d27dd9adefce9", dateModified: "2026-09-28" },
};

/** Data ostatniej istotnej zmiany treści danej strony (YYYY-MM-DD). */
export function contentDate(path: string, fallback?: string): string | undefined {
  return contentDates[path]?.dateModified ?? fallback;
}
